import { render, staticRenderFns } from "./CloneButton.vue?vue&type=template&id=b865c5d8&scoped=true"
import script from "./CloneButton.vue?vue&type=script&lang=js"
export * from "./CloneButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b865c5d8",
  null
  
)

export default component.exports